<template>
    <div>
        <!-- Button trigger modal -->
        <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
            style="display:none;">
        </button>
        <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
            style="display:none;"></button>
        <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <register2 v-if="useRegisterOther" ref="register" v-bind:skin="skin" v-bind:language="language"
            v-bind:translation="translation" />
        <register v-else ref="register" v-bind:skin="skin" v-bind:language="language"
            v-bind:translation="translation" />
        <availableBonuses ref="availableBonuses" :skin="skin" :token="user.token" :user="user" />
        <nav v-if="user.token !== ''" class="navbarCustom navbar-dark py-0" id="mainHeader">
            <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation"
                :show-bonuses-button="!!skin.bonos" :show-bonus-balances="!!skin.bonos"
                :casino-bonus-balance="casinoBonusBalance"
                :sportsbook-bonus-balance="sportsbookBonusBalance" mobile-experience @open-bonuses="openBonuses" />
            <div class="authenticated-header d-flex" :style="skin.header_mobil.nav_bar">
                <span class="authenticated-header__menu position-relative" @click="toggleSidebar">
                    <span style="font-size: large;"><i :class="lateralMenuOpen ? 'fas fa-times' : 'fas fa-bars'"></i></span>
                </span>
                <div class="authenticated-header__logo float-left" @click="change_view('lobby')"
                    style="cursor:pointer;">
                    <img v-if="skin.header_mobil.logo != ''" :src="skin.header_mobil.logo"
                        :width="skin.header_mobil.logo_width" alt="" class="authenticated-header__logo-image">
                </div>
                <div class="authenticated-header__actions d-flex align-items-center" :style="skin.header_desktop.nav_bar_text">

                    <div v-if="user.token != ''" class="authenticated-header__balance text-center">
                        <div v-if="skin.header_desktop.balance" class="authenticated-header__balance-item nav-item"
                            :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                            style="cursor:pointer;font-size: 15px;"
                            :style="skin.header_desktop.nav_bar_text">
                            <div style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;" class="text-center"
                                :style="skin.header_desktop.login_btn">
                                <div @click="openBalanceGateway"
                                    class="authenticated-header__balance-button p-2 d-flex" style="cursor:pointer; border-radius: 6.25rem;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <span class="authenticated-header__balance-value">{{ user.user_data.data ? new
                                        Intl.NumberFormat("de-DE", {
                                            minimumFractionDigits:
                                                skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                skin.qBet_config.decimalsQty
                                        }).format(balance.saldo) : 0 }}
                                    </span>
                                    <span :style="skin.header_desktop.nav_bar_text" class="authenticated-header__currency">
                                        {{ user.user_data?.data?.currency}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div v-if="showRechargeShortcut" class="authenticated-header__recharge nav-item">
                            <div @click="change_view('espiral_app')" role="button"
                                :title="translate('Recargas')" :aria-label="translate('Recargas')"
                                style="cursor:pointer;overflow:hidden;border-radius:50%;" class="text-center"
                                :style="skin.header_desktop.login_btn">
                                <div class="p-2" style="cursor:pointer;border-radius:50%;"
                                    :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                    <i class="fas fa-wallet" style="font-size:1.2rem;" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    <div v-if="showGamanzaMobileAvatar" class="authenticated-header__account py-0 my-0 text-center nav-item">
                        <gamanza-avatar :skin="skin" :language="language" show-level-badge external-panel
                            @open-panel="openGamanzaMobileAccount" />
                    </div>
                    <div v-else style="cursor:pointer;"
                        class="authenticated-header__account py-0 my-0 text-center nav-item dropdown dropstart" data-bs-toggle="modal"
                        data-bs-target="#myAccountJm" @click="handleUserMenuClick">
                        <div style="cursor:pointer;overflow: hidden;border-radius: 50%;" class="text-center"
                            :style="skin.header_desktop.login_btn">
                            <div class="p-2" style="cursor:pointer;border-radius: 50%;"
                                :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background">
                                <svg style="width: 1.3rem;height: 1.3rem;" viewBox="0 0 28 28" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.927" fill-rule="evenodd" clip-rule="evenodd"
                                        d="M12.9135 3.03401C15.0685 2.82516 16.7883 3.57826 18.0732 5.29327C19.2707 7.30272 19.2503 9.29735 18.0121 11.2773C16.2174 13.4382 14.009 13.998 11.387 12.9564C9.1058 11.6401 8.17969 9.67599 8.6087 7.06404C9.06434 5.32624 10.1126 4.09488 11.7533 3.36984C12.1402 3.23005 12.5269 3.1181 12.9135 3.03401ZM13.1578 4.01098C15.535 3.92135 17.0921 5.00011 17.8289 7.24722C18.1823 9.29814 17.4801 10.8756 15.7223 11.9795C13.93 12.8051 12.2813 12.5812 10.7764 11.3078C9.3153 9.68283 9.10159 7.90186 10.1352 5.96494C10.8817 4.90504 11.8892 4.25376 13.1578 4.01098Z"
                                        fill="white" stroke="white" stroke-width="1.04211"></path>
                                    <path opacity="0.941" fill-rule="evenodd" clip-rule="evenodd"
                                        d="M8.63947 15.6562C12.0386 15.646 15.4376 15.6562 18.8367 15.6867C20.6071 15.9309 21.8792 16.857 22.653 18.465C23.4354 20.6559 22.9571 22.5182 21.2181 24.0521C20.6491 24.466 20.0181 24.7509 19.3252 24.9069C15.7446 25.007 12.1623 25.0273 8.57841 24.968C6.28838 24.5505 4.93484 23.197 4.51785 20.9074C4.35399 18.68 5.25974 17.0619 7.23507 16.0531C7.69736 15.8716 8.16552 15.7393 8.63947 15.6562ZM8.94478 16.6331C12.1404 16.6229 15.3359 16.6331 18.5314 16.6637C20.6885 16.9584 21.8487 18.1898 22.0119 20.3579C21.8942 22.2513 20.9172 23.442 19.0809 23.9299C15.6834 24.0297 12.2843 24.05 8.88372 23.991C7.12241 23.7358 6.01312 22.7487 5.55589 21.0295C5.32764 19.1013 6.09091 17.7274 7.84568 16.9079C8.21076 16.776 8.57713 16.6844 8.94478 16.6331Z"
                                        fill="white" stroke="white" stroke-width="1.04211"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <nav v-else class="navbarCustom navbar-dark py-0" id="mainHeader">
            <div class="guest-header d-flex align-items-center" :style="skin.header_mobil.nav_bar">

                <span class="guest-header__menu position-relative me-2" @click="toggleSidebar">
                    <span style="color:#ccc;font-size: large;"><i :class="lateralMenuOpen ? 'fas fa-times' : 'fas fa-bars'"></i></span>
                </span>
                <div class="guest-header__logo"><img class="guest-header__logo-image mx-2" :src="skin.header_mobil.logo"
                        :width="skin.header_mobil.logo_width" alt="">
                </div>
                <div v-if="(user.token == '' && skin.register)" class="guest-header__action p-1"
                    style="width: 28.5%;border-radius: 6.25rem;">
                    <div class="guest-header__button p-2 text-center" @click="register"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_mobil.nav_bar_text + skin.header_desktop.register_btn">
                        <span>{{ translate("sign_in") }}</span>
                    </div>
                </div>
                <div :style="skin.header_mobil.login_btn" class="guest-header__action p-1" style="width: 30%;">
                    <div class="guest-header__button p-2 text-center" @click="login"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_mobil.nav_bar_text + skin.header_desktop.selection">
                        <span style="font-size: 14px; white-space: nowrap;"> {{ translate("log_in") }}</span>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import myAccountJM from "./my_account.vue";
import login from "./login_mobil.vue";
import register from './register.vue';
import register2 from './register2.vue';
import historialIngresos from "./historialIngresos.vue";
import availableBonuses from "./bonuses.vue";
import GamanzaAvatar from '../../gamanza/GamanzaAvatar.vue';
import axios from 'axios';
import { shouldUseGamanzaProfileDropdown } from '../../../utils/gamanzaProfileDropdown';

import { getPromotionsApiKey, getPromotionsApiUrl } from '../../../services/promotionsApi';

export default {
    name: "header_mobil",
    props: ["skin", "translation", "language"],
    components: { myAccountJM, login, register, register2, historialIngresos, availableBonuses, GamanzaAvatar },
    data() {
        return {
            userDataLoaded: false,
            showBalance: false,
            supportTickets: [],
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            casinoBonusBalance: 0,
            sportsbookBonusBalance: 0,
            saldo_interval: null,
        }
    },
    computed: {
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        gamanzaReady() {
            return this.$store.getters['getGamanzaReady'];
        },
        showGamanzaMobileAvatar() {
            return shouldUseGamanzaProfileDropdown({
                skin: this.skin,
                user: this.user,
                gamanzaReady: this.gamanzaReady
            });
        },
        hasLateralMenu() {
            return !!this.skin?.lateral_menu?.enabled;
        },
        lateralMenuOpen() {
            return this.$store.getters['getLateralMenu'];
        },
        useRegisterOther() {
            return Boolean(this.skin && this.skin.register_other);
        },
        canUseTonder() {
            return Number(this.user?.user_data?.data?.edit_tickets) === 0;
        },
        bonusPlayerKey() {
            if (!this.skin?.bonos) return '';
            const playerId = this.user?.user_data?.data?.user_id;
            const siteId = this.user?.site_id ?? this.user?.user_data?.data?.site_id;
            return playerId && siteId ? `${playerId}_${siteId}` : '';
        },
        showRechargeShortcut() {
            return Boolean(
                this.skin?.header_mobil?.cashier_shortcuts?.deposits &&
                this.skin?.espiral_app &&
                this.skin?.categories?.some(category => category.active && category.category === 'espiral_app')
            );
        },
    },
    methods: {
        async loadBonusBalances(playerKey) {
            try {
                const response = await axios.get(
                    `${getPromotionsApiUrl(this.$store.getters.getDomain)}/bonus/balance/${encodeURIComponent(playerKey)}`,
                    {
                        headers: {
                            'w-api-key': getPromotionsApiKey(this.$store.getters.getDomain),
                            'w-api-token': `${this.$store.state.user_token}_${this.user.site_id}`
                        }
                    }
                );
                const bonusBalances = response.data?.data ?? response.data;

                this.casinoBonusBalance = Number(bonusBalances?.casino_bonus_balance) || 0;
                this.sportsbookBonusBalance = Number(bonusBalances?.sportsbook_bonus_balance) || 0;
            } catch (error) {
                this.casinoBonusBalance = 0;
                this.sportsbookBonusBalance = 0;
            }
        },
        handleUserMenuClick() {
            const playerKey = this.bonusPlayerKey;

            if (playerKey) {
                this.loadBonusBalances(playerKey);
            }
        },
        openGamanzaMobileAccount() {
            this.handleUserMenuClick();

            const accountModalElement = document.getElementById('myAccountJm');
            const bs = window.bootstrap;

            if (!accountModalElement || !bs?.Modal) return;

            bs.Modal.getOrCreateInstance(accountModalElement).show();
        },
        openBalanceGateway() {
            if (this.skin.tonder) {
                if (this.canUseTonder) {
                    this.change_view_two('tonder');
                }
                return;
            }

            if (this.skin.espiral_app) {
                this.change_view_two('espiral_app');
            }
        },
        openBonuses(event) {
            const accountModalElement = document.getElementById('myAccountJm');
            const bonusesModalElement = document.getElementById('availableBonuses');
            const bs = window.bootstrap;
            const triggerElement = event?.currentTarget;

            if (!accountModalElement || !bonusesModalElement || !bs?.Modal) return;

            this.$refs.availableBonuses.loadBonuses();

            accountModalElement.addEventListener('hidden.bs.modal', () => {
                bs.Modal.getOrCreateInstance(bonusesModalElement).show(triggerElement);
            }, { once: true });

            bs.Modal.getOrCreateInstance(accountModalElement).hide();
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        openSupportModalJivo() {
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        show_user_recharge() {
            this.$root.$emit("show_user_recharge");
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        login() {
            document.getElementById('login_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        register() {
            document.getElementById('register_btn').click();
        },
        change_view(view) {
            this.$store.dispatch('changeView', view);
        },
        change_view_two(view) {
            this.$store.dispatch("changeView", view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        toggleSidebar() {
            this.$store.dispatch('toggleLateralMenu');
            const targetId = this.hasLateralMenu ? 'offcanvasLateral' : 'offcanvasExample';
            const el = document.getElementById(targetId);
            if (el) {
                const bs = window.bootstrap;
                if (bs && bs.Offcanvas) {
                    const instance = bs.Offcanvas.getInstance(el) || new bs.Offcanvas(el);
                    if (this.lateralMenuOpen) {
                        instance.show();
                    } else {
                        instance.hide();
                    }
                }
            }
        },
    },
    watch: {
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        this.$root.$on('openLogin', () => {
            this.login();
        });
        this._syncOffcanvasState = () => {
            if (!this.lateralMenuOpen) {
                this.$store.dispatch('setLateralMenu', true);
            }
        };
        this._syncOffcanvasClosed = () => {
            if (this.lateralMenuOpen) {
                this.$store.dispatch('setLateralMenu', false);
            }
        };
        const targetId = this.hasLateralMenu ? 'offcanvasLateral' : 'offcanvasExample';
        const el = document.getElementById(targetId);
        if (el) {
            el.addEventListener('shown.bs.offcanvas', this._syncOffcanvasState);
            el.addEventListener('hidden.bs.offcanvas', this._syncOffcanvasClosed);
        }
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        this.saldo_interval = setInterval(function () {
            try {
                if (self.user.user_data.data) {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                self.$store.dispatch('logOut');
                if (self.saldo_interval) {
                    clearInterval(self.saldo_interval);
                }
            }
        }, balanceRequestTime);
    }, beforeDestroy() {
        this.$root.$off('openLogin');

        if (this.saldo_interval) {
            clearInterval(this.saldo_interval);
        }
    }
}
</script>

<style>
.navbarCustom {
    border: none;
    background-color: #1c1c1c;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.authenticated-header {
    align-items: center !important;
    box-sizing: border-box;
    min-height: 50px;
    padding: 4px 8px;
    width: 100%;
}

.authenticated-header__menu {
    align-items: center;
    align-self: stretch;
    cursor: pointer;
    display: flex;
    flex: 0 0 44px;
    justify-content: center;
    max-width: 44px;
}

.authenticated-header__logo {
    align-items: center;
    display: flex;
    flex: 0 1 clamp(80px, 28vw, 140px);
    justify-content: flex-start;
    max-width: clamp(80px, 28vw, 140px);
    min-width: 0;
    overflow: hidden;
}

.authenticated-header__logo-image {
    display: block;
    height: auto;
    max-width: 100%;
    object-fit: contain;
}

.authenticated-header__actions {
    align-items: center !important;
    flex: 1 1 0;
    justify-content: flex-end;
    min-width: 0;
}

.authenticated-header__balance {
    align-items: center !important;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 auto;
    gap: 4px;
    justify-content: flex-end;
    min-width: 100px;
    padding-left: 4px;
    padding-right: 4px;
}

.authenticated-header__balance-item {
    flex: 1 1 auto;
    min-width: 0;
}

.authenticated-header__balance-button {
    align-items: center !important;
    justify-content: center;
    min-height: 40px;
    min-width: 0;
    white-space: nowrap;
    width: 100%;
}

.authenticated-header__balance-value {
    flex: 0 0 auto;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.authenticated-header__currency {
    flex: 0 0 auto;
    margin-left: 4px;
}

.authenticated-header__recharge {
    align-items: center !important;
    display: flex;
    flex: 0 0 40px;
    justify-content: center;
    min-width: 40px;
}

.authenticated-header__account {
    align-items: center !important;
    display: flex;
    flex: 0 0 44px;
    justify-content: center;
    max-width: 44px;
}

@media (max-width: 380px) {
    .authenticated-header {
        padding-left: 4px;
        padding-right: 4px;
    }

    .authenticated-header__menu {
        flex-basis: 36px;
        max-width: 36px;
    }

    .authenticated-header__balance {
        min-width: 92px;
        padding-left: 2px;
        padding-right: 2px;
    }

    .authenticated-header__balance-button {
        font-size: 12px;
        padding-left: 4px !important;
        padding-right: 4px !important;
    }

    .authenticated-header__recharge {
        flex-basis: 36px;
        min-width: 36px;
    }

    .authenticated-header__account {
        flex-basis: 40px;
        max-width: 40px;
    }
}

@media (max-width: 340px) {
    .authenticated-header__currency {
        display: none;
    }
}

.guest-header {
    min-height: 50px;
    width: 100%;
}

.guest-header__menu {
    align-items: center;
    align-self: stretch;
    cursor: pointer;
    display: flex;
    flex: 0 0 10%;
    justify-content: center;
    min-width: 44px;
}

.guest-header__logo {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
}

.guest-header__logo-image {
    display: block;
    height: auto;
    max-width: 100%;
}

.guest-header__action {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 0 1 auto;
}

.guest-header__button {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 40px;
    width: 100%;
}
</style>
